export default function getHelpEmail(): JSX.Element {
  return <a href='mailto: terraware-support@terraformation.com'>terraware-support@terraformation.com</a>;
}
